import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { SecondaryHeading } from 'components/Headings';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

import { FONT_COLORS } from './constants';

const Headline = ({ headline, textColor, isPortrait }) => (
  <div className={classNames('Headline__wrapper', { 'Headline__wrapper--portrait': isPortrait })}>
    <SecondaryHeading className="Headline">{headline}</SecondaryHeading>
    <style jsx>
      {`
        .Headline__wrapper {
          width: 100%;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: ${Theme.get('spacing') * 8}px;
        }

        .Headline__wrapper--portrait {
          padding: 0 ${Theme.get('spacing') * 3}px;
          margin-bottom: ${Theme.get('spacing') * 3}px;
        }

        @media ${mediumUp} {
          .Headline__wrapper--portrait {
            padding: 0 ${Theme.get('spacing') * 6}px;
          }
        }
      `}
    </style>
    <style jsx global>
      {`
        .typography--secondary-heading.Headline {
          color: ${Theme.get(`colors-${textColor}`)};
        }
      `}
    </style>
  </div>
);

Headline.propTypes = {
  headline: PropTypes.string.isRequired,
  textColor: PropTypes.oneOf(Object.values(FONT_COLORS)).isRequired,
  isPortrait: PropTypes.bool.isRequired,
};

export default Headline;
